import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import MerchantShopNowLinkLabel from 'core/modules/MerchantShopNowLinkLabel/MerchantShopNowLinkLabel';
import {
  addPeriodAfterOfferRolloverCopy,
} from 'core/utils/apis/responseParsers/commonParsers/addPeriodAfterOfferRolloverCopy';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import dayjs from 'core/utils/dayjs';

import orgConfig from 'org/configs/org.config';

function MerchantLetterboxTile({
  id, dealId, merchant, clickUrl, assets, disclaimer, couponCode,
  stopDatetime, isOngoing, showRebateTierName, shouldUseExtraPillView, config,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasToggleMenu = !!disclaimer;
  const isMobileMQ = useSelector(selectIsMobileMQ);

  useEffect(() => {
    if (hasToggleMenu) {
      setIsExpanded(false);
    }
  }, [hasToggleMenu, disclaimer]);

  const handleClick = (event) => {
    const isCTAButtonClicked = event.target.className.includes('mn_button');
    if (hasToggleMenu && !isCTAButtonClicked && isMobileMQ) {
      event.preventDefault();

      setIsExpanded(!isExpanded);
    }
  };

  const rolloverCopyFormatted = addPeriodAfterOfferRolloverCopy(assets.rolloverCopy);
  const isRolloverCopyLong = rolloverCopyFormatted && rolloverCopyFormatted.length > 21;
  const rolloverCopyClassName = `mn_rolloverCopy ${isRolloverCopyLong ? 'mn_longCopy' : ''}`;
  const {
    dateFormat, getCouponCodeLabelText, rebateOptions, expiresPrefix, labelText,
    getShouldUseRowMobileView,
  } = config;
  const { extraRewardsName } = orgConfig;

  const couponCodeLabelText = getCouponCodeLabelText(isMobileMQ);
  const shouldUseRowMobileView = getShouldUseRowMobileView(isMobileMQ);

  /* eslint-disable-next-line max-len */
  const merchantLinkClassNames = `mn_letterboxTile mn_merchantLetterboxTile ${shouldUseExtraPillView ? 'mn_merchantLetterboxTileWithExtraPill' : ''}`;
  const expiresDate = dayjs.parseZone(stopDatetime).format(dateFormat);

  const renderRowMobileView = () => (
    <>
      <ExtraRewardsPill rebate={merchant.rebate} label="Extra miles" />
      <div className="mn_logoAndRebateWrapper">
        <img
          className="mn_merchantLogo mn_merchant88Logo"
          src={merchant.logoUrls._88x31}
          alt={merchant.name}
        />
        <PremierMerchantRebate
          {...merchant.rebate}
          showRebateTierName={showRebateTierName}
          {...rebateOptions}
        />
      </div>
      <p className={rolloverCopyClassName}>{rolloverCopyFormatted}</p>
      {!isEmpty(couponCode) && (
        <div className="mn_couponCode">
          <span className="mn_couponCodeLabel">{couponCodeLabelText}</span>
          <span className="mn_couponCodeValue">{couponCode}</span>
        </div>
      )}
      <span className="mn_expire">
        {isOngoing ? <> Ongoing</> : <> {expiresPrefix}{expiresDate}</>}
      </span>
    </>
  );

  const renderOfferDetailsTop = () => (
    <div className="mn_offerDetailsTop">
      <img
        className="mn_merchantLogo mn_merchant88Logo"
        src={merchant.logoUrls._88x31}
        alt={merchant.name}
      />
      <img
        className="mn_merchantLogo mn_merchant120Logo"
        src={merchant.logoUrls._120x60}
        alt={merchant.name}
      />
      {shouldUseExtraPillView && (
        <>
          <ExtraRewardsPill rebate={merchant.rebate} label={labelText || extraRewardsName} />
          <PremierMerchantRebate
            {...merchant.rebate}
            showRebateTierName={showRebateTierName}
            {...rebateOptions}
          />
        </>
      )}
      <p className={rolloverCopyClassName}>
        {rolloverCopyFormatted}
        <span className="mn_expire">
          {isOngoing ? <> Ongoing</> : <> {expiresPrefix}{expiresDate}</>}
        </span>
      </p>
      {!isEmpty(couponCode) && (
        <div className="mn_couponCode">
          <span className="mn_couponCodeLabel">{couponCodeLabelText}</span>
          <span className="mn_couponCodeValue">{couponCode}</span>
        </div>
      )}
    </div>
  );

  return (
    <a
      href={clickUrl}
      target="_blank"
      aria-expanded={isExpanded}
      title={`Opens a new window at name ${merchant.name}`}
      data-placement-id={id}
      data-deal-id={dealId}
      data-merchant-id={merchant.id}
      data-merchant-name={merchant.name}
      data-has-toggle-menu={hasToggleMenu}
      onClick={handleClick}
      className={merchantLinkClassNames}
    >
      <figure className="mn_letterboxTileImage">
        <img data-test="merchant-image" src={assets._420x295} alt={assets.imageAlternateText} />
      </figure>
      <div className={`mn_offerDetails ${shouldUseRowMobileView ? 'mn_rowOfferDetails' : ''}`}>
        {shouldUseRowMobileView ? renderRowMobileView() : renderOfferDetailsTop()}
        {!shouldUseExtraPillView && merchant.rebate && (
          <PremierMerchantRebate
            {...merchant.rebate}
            showRebateTierName={showRebateTierName}
            {...rebateOptions}
          />
        )}
        <div className={`mn_offerDetailsBottom ${isExpanded ? 'mn_expanded' : 'mn_collapsed'}`}>
          <div className="mn_offerDetailsBottomInner">
            <button className="mn_button mn_shopNow">
              <MerchantShopNowLinkLabel merchant={merchant} />
            </button>
          </div>
          {disclaimer && <div className="mn_exclusion">{disclaimer}</div>}
        </div>
      </div>
    </a>
  );
}

export default MerchantLetterboxTile;
